import React from 'react';
import { Image, List, Segment, Header, Grid, Statistic, Popup } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { fetchCurrentAcademicYear, fetchPreviousAcademicYear } from '../Lookups/util';
import { Link } from 'react-router-dom';
import axios from 'axios';
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

const fetchBHStudents = (academicYear) => axios.get(`/statistics/enrolled-per-entity-for-BiH-for-university/?academicYearId=${academicYear}`);
const fetchForeignStudents = (academicYear) => axios.get(`/statistics/enrolled-per-foreign-country-for-university/?academicYearId=${academicYear}`);
const fetchGraduatedStudents = (academicYear) => axios.get(`/statistics/graduated-per-study-cycle-for-university/?academicYearId=${academicYear}`);

export default class Statistics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            graduatedStudentsData: [],
            BHStudentsData: [],
            foreignStudentsData: [],

            currentAcademicYear: '',
            previousAcademicYear: '',

            studyCycles: [],
        };

        this.generateStatisticsData = this.generateStatisticsData.bind(this);
        this.countGraduatedStudents = this.countGraduatedStudents.bind(this);
        this.countBHStudents = this.countBHStudents.bind(this);
        this.countForeignStudents = this.countForeignStudents.bind(this);
    }

    componentDidMount() {
        axios.all([fetchCurrentAcademicYear(), fetchPreviousAcademicYear()])
            .then(axios.spread((currentAcademicYearRes, previousAcademicYearRes) => {
                const currentAcademicYear = currentAcademicYearRes.data.id;
                const previousAcademicYear = previousAcademicYearRes.data.id;
                this.setState({ previousAcademicYear, currentAcademicYear, loading: false });
                this.generateStatisticsData(currentAcademicYear, previousAcademicYear);
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch academic years');
            });
    }

    countGraduatedStudents() {
        const { graduatedStudentsData } = this.state;
        return graduatedStudentsData.reduce((a, c) => a + c.value, 0);
    }

    countBHStudents() {
        const { BHStudentsData } = this.state;
        return BHStudentsData.reduce((a, c) => a + c.value, 0);
    }

    countForeignStudents() {
        const { foreignStudentsData } = this.state;
        return foreignStudentsData.reduce((a, c) => a + c.value, 0);
    }

    generateStatisticsData(currentAcademicYear, previousAcademicYear) {
        axios.all([fetchBHStudents(currentAcademicYear), fetchForeignStudents(currentAcademicYear), fetchGraduatedStudents(previousAcademicYear)])
            .then(axios.spread((BHStudentsRes, foreignStudentsRes, graduatedStudentsRes) => {
                const BHStudentsData = BHStudentsRes.data.map(el => ({
                    ...el, name: el.placeId, value: el.numberOfStudents
                }));
                const foreignStudentsData = foreignStudentsRes.data.map(el => ({
                    ...el, name: el.placeId, value: el.numberOfStudents
                }));
                const graduatedStudentsData = graduatedStudentsRes.data.map(el => ({
                    ...el, name: el.studyCycleId, value: el.numberOfStudents
                }));
                this.setState({
                    BHStudentsData, foreignStudentsData, graduatedStudentsData
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch data results');
            });
    }


    render() {
        return (
            <div >
                <Header as="h1">{<FormattedMessage id="statistics.statistic" />}</Header>

                <Grid columns={3} centered className="stackable">
                    <Grid.Row stretched>
                        <Grid.Column>
                            <Segment raised>
                                <Statistic.Group widths="one">
                                    <Statistic color="teal">
                                        <Popup
                                            trigger={<Statistic.Value>{this.countGraduatedStudents()}</Statistic.Value>}
                                            content="2017/2018 akademska godina"
                                            hideOnScroll
                                            position="top center"
                                        />

                                        <Statistic.Label>{<FormattedMessage id="statistics.graduated" />}</Statistic.Label>
                                    </Statistic>
                                </Statistic.Group>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column>
                            <Segment raised>
                                <Statistic.Group widths="one">
                                    <Statistic color="blue">
                                        <Popup
                                            trigger={<Statistic.Value>{this.countBHStudents()}</Statistic.Value>}
                                            content="2018/2019 akademska godina"
                                            hideOnScroll
                                            position="top center"
                                        />

                                        <Statistic.Label>{<FormattedMessage id="statistics.enrollledBiH" />}</Statistic.Label>
                                    </Statistic>
                                </Statistic.Group>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column>
                            <Segment raised>
                                <Statistic.Group widths="one">
                                    <Statistic color="teal">
                                        <Popup
                                            trigger={<Statistic.Value>{this.countForeignStudents()}</Statistic.Value>}
                                            content="2018/2019 akademska godina"
                                            hideOnScroll
                                            position="top center"
                                        />
                                        <Statistic.Label>{<FormattedMessage id="statistics.enrolledOther" />}</Statistic.Label>
                                    </Statistic>
                                </Statistic.Group>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid columns={3} centered className="stackable">
                    <Grid.Row stretched>
                        <Grid.Column>
                            <Segment.Group raised style={{ backgroundColor: 'white' }}>
                                <Segment raised>
                                    <Header as="h3">
                                        {<FormattedMessage id="statistics.graduatedStudents" />}
                                    </Header>
                                </Segment>
                                <Segment raised>
                                    <List selection verticalAlign="middle">
                                        <List.Item>
                                            <Image avatar src="https://cdn4.iconfinder.com/data/icons/financial/100/2-512.png" />
                                            <List.Content>
                                                <List.Header>
                                                    <Link to="/statistika/diplomirani-po-ciklusima">
                                                        {<FormattedMessage id="statistics.perCyclesForFaculty" />}
                                                    </Link>
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>

                                        <List.Item>
                                            <Image avatar src="https://cdn3.iconfinder.com/data/icons/gray-toolbar-3/512/charts-512.png" />
                                            <List.Content>
                                                <List.Header>
                                                    <Link to="/statistika/diplomirani-prema-spolu">
                                                        {<FormattedMessage id="statistics.perCyclesForFacultyMF" />}
                                                    </Link>
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>

                                        <List.Item>
                                            <Image avatar src="https://cdn4.iconfinder.com/data/icons/financial/100/2-512.png" />
                                            <List.Content>
                                                <List.Header>
                                                    <Link to="/statistika/diplomirani-po-ciklusima-za-univerzitet">
                                                        {<FormattedMessage id="statistics.perCyclesForUniversity" />}
                                                    </Link>
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>

                                        {/* <List.Item>
                                        <Image avatar src="https://cdn3.iconfinder.com/data/icons/gray-toolbar-3/512/charts-512.png" />
                                        <List.Content>
                                            <List.Header>
                                                <Link to="/statistika/diplomirani-po-fakultetima">
                              Po fakultetima za određeni ciklus
                                                </Link>
                                            </List.Header>
                                        </List.Content>
                                    </List.Item>
*/}
                                    </List>
                                </Segment>

                            </Segment.Group>
                        </Grid.Column>

                        <Grid.Column>
                            <Segment.Group raised>
                                <Segment raised>
                                    <Header as="h3">
                                        {<FormattedMessage id="statistics.enrolledPerFaculty" />}
                                    </Header>
                                </Segment>
                                <Segment raised>
                                    <List selection verticalAlign="middle" >
                                        <List.Item>
                                            <Image avatar src="https://cdn4.iconfinder.com/data/icons/financial/100/2-512.png" />
                                            <List.Content>
                                                <List.Header>
                                                    <Link to="/statistika/upisani-po-ciklusima">
                                                        {<FormattedMessage id="statistics.perCycles" />}

                                                    </Link>
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>

                                        <List.Item>
                                            <Image avatar src="https://cdn3.iconfinder.com/data/icons/gray-toolbar-3/512/charts-512.png" />
                                            <List.Content>
                                                <List.Header>
                                                    <Link to="/statistika/upisani-prema-statusu-studiranja">
                                                        {<FormattedMessage id="statistics.perStudyType" />}

                                                    </Link>
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>

                                        <List.Item>
                                            <Image avatar src="https://cdn4.iconfinder.com/data/icons/financial/100/2-512.png" />
                                            <List.Content>
                                                <List.Header>
                                                    <Link to="/statistika/upisani-po-drzavama">
                                                        {<FormattedMessage id="statistics.perCountries" />}
                                                    </Link>
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                        <List.Item>
                                            <Image avatar src="https://cdn3.iconfinder.com/data/icons/gray-toolbar-3/512/charts-512.png" />
                                            <List.Content>
                                                <List.Header>
                                                    <Link to="/statistika/upisani-po-studijskim-godinama-i-ciklusima">
                                                        {<FormattedMessage id="statistics.perStudyYearAndCycles" />}

                                                    </Link>
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                        <List.Item>
                                            <Image avatar src="https://cdn4.iconfinder.com/data/icons/financial/100/2-512.png" />
                                            <List.Content>
                                                <List.Header>
                                                    <Link to="/statistika/upisani-po-opcinama">
                                                        {<FormattedMessage id="statistics.perMunicipality" />}

                                                    </Link>
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                    </List>
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>

                        <Grid.Column>
                            <Segment.Group raised>
                                <Segment raised>
                                    <Header as="h3">
                                        {<FormattedMessage id="statistics.enrolledForUniversity" />}

                                    </Header>
                                </Segment>
                                <Segment raised>
                                    <List selection verticalAlign="middle" >
                                        <List.Item>
                                            <Image avatar src="https://cdn4.iconfinder.com/data/icons/financial/100/2-512.png" />
                                            <List.Content>
                                                <List.Header>
                                                    <Link to="/statistika/upisani-po-ciklusima-za-univerzitet">
                                                        {<FormattedMessage id="statistics.perCycles" />}

                                                    </Link>
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                        <List.Item>
                                            <Image avatar src="https://cdn3.iconfinder.com/data/icons/gray-toolbar-3/512/charts-512.png" />
                                            <List.Content>
                                                <List.Header>
                                                    <Link to="/statistika/upisani-prema-statusu-studiranja-za-univerzitet">
                                                        {<FormattedMessage id="statistics.perStudyType" />}

                                                    </Link>
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                        <List.Item>
                                            <Image avatar src="https://cdn4.iconfinder.com/data/icons/financial/100/2-512.png" />
                                            <List.Content>
                                                <List.Header>
                                                    <Link to="/statistika/upisani-po-drzavama-za-univerzitet">
                                                        {<FormattedMessage id="statistics.perCountries" />}

                                                    </Link>
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                        <List.Item>
                                            <Image avatar src="https://cdn3.iconfinder.com/data/icons/gray-toolbar-3/512/charts-512.png" />
                                            <List.Content>
                                                <List.Header>
                                                    <Link to="/statistika/upisani-po-studijskim-godinama-i-ciklusima-za-univerzitet">
                                                        {<FormattedMessage id="statistics.perStudyYearAndCycles" />}

                                                    </Link>
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                        <List.Item>
                                            <Image avatar src="https://cdn4.iconfinder.com/data/icons/financial/100/2-512.png" />
                                            <List.Content>
                                                <List.Header>
                                                    <Link to="/statistika/upisani-po-opcinama-za-univerzitet">
                                                        {<FormattedMessage id="statistics.perMunicipality" />}

                                                    </Link>
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                    </List>
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Statistics/Statistics.js